import { CompanySettings } from "../Services/Agrisys_GqlDataCaller/UserCalls/GQLCalls/companySettingsCalls";
import { getFarmSettingsState } from "../Services/Agrisys_GqlDataCaller/UserCalls/dataCalls";
import store from "../Store";

export class LocaleFarmDate {
  private farmSettings: CompanySettings | undefined;
  private date: Date | undefined;

  constructor(value: number | string | Date) {
    const suggestedDate = new Date(value);
    if (!isNaN(suggestedDate.valueOf())) {
      this.date = suggestedDate;
    }
    this.farmSettings = getFarmSettingsState(store.getState());
  }
  
  static restrictTimeTo24Hours(value:number): number {
    const dayInMinutes = 24*60
  
    return (((value % dayInMinutes) + dayInMinutes) % dayInMinutes);
  }

  toLocaleFarmString() {
    if (this.date === undefined) {
      return ""
    }
    
    return new Intl.DateTimeFormat(
      "default",
      {
        timeZone: this.farmSettings?.time_zone_label,
        dateStyle: "short",
        timeStyle: "long",
      }
    ).format(this.date);
  }
  
  toDateForInput() {
    if (this.date === undefined) {
      return ""
    }
    // Sweden follow the ISO standard format
   return new Intl.DateTimeFormat('sv', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      timeZone: this.farmSettings?.time_zone_label
    }).format(this.date);
  }
  
  toDateForDisplay() {
    if (this.date === undefined) {
      return ""
    }

    return new Intl.DateTimeFormat('dk', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      timeZone: this.farmSettings?.time_zone_label
    }).format(this.date);
  }
  
  toDayMonth() {
    if (this.date === undefined) {
      return ""
    }

    return new Intl.DateTimeFormat('dk',
      {
        day: '2-digit',
        month: '2-digit',
        timeZone: this.farmSettings?.time_zone_label
      }
    ).format(this.date);
  }
  
  toYear() {
    if (this.date === undefined) {
      return ""
    }

    return new Intl.DateTimeFormat('dk',
      {
        year: 'numeric',
        timeZone: this.farmSettings?.time_zone_label
      }
    ).format(this.date);

  }
  
}